/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateClusterRunbookActivityRequestRunbookActivity } from '../models';
// @ts-ignore
import type { ListRunbookActivitiesClusterResponse } from '../models';
// @ts-ignore
import type { ListRunbookActivitiesOrganizationResponse } from '../models';
// @ts-ignore
import type { RunbookActivity } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateRunbookActivityRequest } from '../models';
/**
 * RunbookActivitiesAPIApi - axios parameter creator
 * @export
 */
export const RunbookActivitiesAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates runbook activity for a cluster-scoped runbook.
         * @summary Create runbook activity for a cluster-scoped runbook.
         * @param {string} runbookActivityOrganizationId 
         * @param {string} runbookActivityClusterId 
         * @param {CreateClusterRunbookActivityRequestRunbookActivity} createClusterRunbookActivityRequestRunbookActivity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookActivitiesAPICreateClusterRunbookActivity: async (runbookActivityOrganizationId: string, runbookActivityClusterId: string, createClusterRunbookActivityRequestRunbookActivity: CreateClusterRunbookActivityRequestRunbookActivity, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runbookActivityOrganizationId' is not null or undefined
            assertParamExists('runbookActivitiesAPICreateClusterRunbookActivity', 'runbookActivityOrganizationId', runbookActivityOrganizationId)
            // verify required parameter 'runbookActivityClusterId' is not null or undefined
            assertParamExists('runbookActivitiesAPICreateClusterRunbookActivity', 'runbookActivityClusterId', runbookActivityClusterId)
            // verify required parameter 'createClusterRunbookActivityRequestRunbookActivity' is not null or undefined
            assertParamExists('runbookActivitiesAPICreateClusterRunbookActivity', 'createClusterRunbookActivityRequestRunbookActivity', createClusterRunbookActivityRequestRunbookActivity)
            const localVarPath = `/application-automation/v1alpha/organizations/{runbook_activity.organization_id}/clusters/{runbook_activity.cluster_id}/runbook-activities`
                .replace(`{${"runbook_activity.organization_id"}}`, encodeURIComponent(String(runbookActivityOrganizationId)))
                .replace(`{${"runbook_activity.cluster_id"}}`, encodeURIComponent(String(runbookActivityClusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClusterRunbookActivityRequestRunbookActivity, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List runbook activities for a cluster-scoped runbook.
         * @summary List runbook activities for a cluster-scoped runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [runbookId] The ID of the runbook.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {RunbookActivitiesAPIListRunbookActivitiesClusterTypeEnum} [type] The type of the runbook activity.
         * @param {RunbookActivitiesAPIListRunbookActivitiesClusterRunbookTypeEnum} [runbookType] The type of the runbook.
         * @param {string} [entityId] The optional entity id.
         * @param {string} [pullRequestMetadataId] The ID of the pull request.
         * @param {string} [pullRequestMetadataUri] The URI of the pull request.
         * @param {string} [pullRequestMetadataBranch] The branch of the pull request.
         * @param {Array<string>} [pullRequestMetadataFilesChanged] A list of files changed in the pull request.
         * @param {RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataStatusEnum} [pullRequestMetadataStatus] The status of the runbook activity.
         * @param {RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataActivityStatusEnum} [pullRequestMetadataActivityStatus] The status of the activity. Used to indicate if this activity is new, or it has already been observed by the agent.
         * @param {string} [runId] The ID of the runbook run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookActivitiesAPIListRunbookActivitiesCluster: async (organizationId: string, clusterId: string, runbookId?: string, pageLimit?: string, pageCursor?: string, type?: RunbookActivitiesAPIListRunbookActivitiesClusterTypeEnum, runbookType?: RunbookActivitiesAPIListRunbookActivitiesClusterRunbookTypeEnum, entityId?: string, pullRequestMetadataId?: string, pullRequestMetadataUri?: string, pullRequestMetadataBranch?: string, pullRequestMetadataFilesChanged?: Array<string>, pullRequestMetadataStatus?: RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataStatusEnum, pullRequestMetadataActivityStatus?: RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataActivityStatusEnum, runId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbookActivitiesAPIListRunbookActivitiesCluster', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('runbookActivitiesAPIListRunbookActivitiesCluster', 'clusterId', clusterId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/runbook-activities`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (runbookId !== undefined) {
                localVarQueryParameter['runbookId'] = runbookId;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (runbookType !== undefined) {
                localVarQueryParameter['runbookType'] = runbookType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (pullRequestMetadataId !== undefined) {
                localVarQueryParameter['pullRequestMetadata.id'] = pullRequestMetadataId;
            }

            if (pullRequestMetadataUri !== undefined) {
                localVarQueryParameter['pullRequestMetadata.uri'] = pullRequestMetadataUri;
            }

            if (pullRequestMetadataBranch !== undefined) {
                localVarQueryParameter['pullRequestMetadata.branch'] = pullRequestMetadataBranch;
            }

            if (pullRequestMetadataFilesChanged) {
                localVarQueryParameter['pullRequestMetadata.filesChanged'] = pullRequestMetadataFilesChanged;
            }

            if (pullRequestMetadataStatus !== undefined) {
                localVarQueryParameter['pullRequestMetadata.status'] = pullRequestMetadataStatus;
            }

            if (pullRequestMetadataActivityStatus !== undefined) {
                localVarQueryParameter['pullRequestMetadata.activityStatus'] = pullRequestMetadataActivityStatus;
            }

            if (runId !== undefined) {
                localVarQueryParameter['runId'] = runId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List runbook activities for an organization-scoped runbook.
         * @summary List runbook activities for an organization-scoped runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [runbookId] The ID of the runbook.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {RunbookActivitiesAPIListRunbookActivitiesOrganizationTypeEnum} [type] The type of the runbook activity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookActivitiesAPIListRunbookActivitiesOrganization: async (organizationId: string, runbookId?: string, pageLimit?: string, pageCursor?: string, type?: RunbookActivitiesAPIListRunbookActivitiesOrganizationTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbookActivitiesAPIListRunbookActivitiesOrganization', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbook-activities`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (runbookId !== undefined) {
                localVarQueryParameter['runbookId'] = runbookId;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates runbook activity for a runbook.
         * @summary Updates runbook activity for a runbook.
         * @param {string} organizationId The ID of the organization this runbook activity belongs to.
         * @param {string} clusterId The ID of the cluster this runbook activity belongs to.
         * @param {string} id The ID of the runbook activity.
         * @param {UpdateRunbookActivityRequest} updateRunbookActivityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookActivitiesAPIUpdateRunbookActivity: async (organizationId: string, clusterId: string, id: string, updateRunbookActivityRequest: UpdateRunbookActivityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbookActivitiesAPIUpdateRunbookActivity', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('runbookActivitiesAPIUpdateRunbookActivity', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('runbookActivitiesAPIUpdateRunbookActivity', 'id', id)
            // verify required parameter 'updateRunbookActivityRequest' is not null or undefined
            assertParamExists('runbookActivitiesAPIUpdateRunbookActivity', 'updateRunbookActivityRequest', updateRunbookActivityRequest)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/runbook-activities/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRunbookActivityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RunbookActivitiesAPIApi - functional programming interface
 * @export
 */
export const RunbookActivitiesAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RunbookActivitiesAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates runbook activity for a cluster-scoped runbook.
         * @summary Create runbook activity for a cluster-scoped runbook.
         * @param {string} runbookActivityOrganizationId 
         * @param {string} runbookActivityClusterId 
         * @param {CreateClusterRunbookActivityRequestRunbookActivity} createClusterRunbookActivityRequestRunbookActivity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookActivitiesAPICreateClusterRunbookActivity(runbookActivityOrganizationId: string, runbookActivityClusterId: string, createClusterRunbookActivityRequestRunbookActivity: CreateClusterRunbookActivityRequestRunbookActivity, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunbookActivity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookActivitiesAPICreateClusterRunbookActivity(runbookActivityOrganizationId, runbookActivityClusterId, createClusterRunbookActivityRequestRunbookActivity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookActivitiesAPIApi.runbookActivitiesAPICreateClusterRunbookActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List runbook activities for a cluster-scoped runbook.
         * @summary List runbook activities for a cluster-scoped runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [runbookId] The ID of the runbook.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {RunbookActivitiesAPIListRunbookActivitiesClusterTypeEnum} [type] The type of the runbook activity.
         * @param {RunbookActivitiesAPIListRunbookActivitiesClusterRunbookTypeEnum} [runbookType] The type of the runbook.
         * @param {string} [entityId] The optional entity id.
         * @param {string} [pullRequestMetadataId] The ID of the pull request.
         * @param {string} [pullRequestMetadataUri] The URI of the pull request.
         * @param {string} [pullRequestMetadataBranch] The branch of the pull request.
         * @param {Array<string>} [pullRequestMetadataFilesChanged] A list of files changed in the pull request.
         * @param {RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataStatusEnum} [pullRequestMetadataStatus] The status of the runbook activity.
         * @param {RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataActivityStatusEnum} [pullRequestMetadataActivityStatus] The status of the activity. Used to indicate if this activity is new, or it has already been observed by the agent.
         * @param {string} [runId] The ID of the runbook run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookActivitiesAPIListRunbookActivitiesCluster(organizationId: string, clusterId: string, runbookId?: string, pageLimit?: string, pageCursor?: string, type?: RunbookActivitiesAPIListRunbookActivitiesClusterTypeEnum, runbookType?: RunbookActivitiesAPIListRunbookActivitiesClusterRunbookTypeEnum, entityId?: string, pullRequestMetadataId?: string, pullRequestMetadataUri?: string, pullRequestMetadataBranch?: string, pullRequestMetadataFilesChanged?: Array<string>, pullRequestMetadataStatus?: RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataStatusEnum, pullRequestMetadataActivityStatus?: RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataActivityStatusEnum, runId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRunbookActivitiesClusterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookActivitiesAPIListRunbookActivitiesCluster(organizationId, clusterId, runbookId, pageLimit, pageCursor, type, runbookType, entityId, pullRequestMetadataId, pullRequestMetadataUri, pullRequestMetadataBranch, pullRequestMetadataFilesChanged, pullRequestMetadataStatus, pullRequestMetadataActivityStatus, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookActivitiesAPIApi.runbookActivitiesAPIListRunbookActivitiesCluster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List runbook activities for an organization-scoped runbook.
         * @summary List runbook activities for an organization-scoped runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [runbookId] The ID of the runbook.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {RunbookActivitiesAPIListRunbookActivitiesOrganizationTypeEnum} [type] The type of the runbook activity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookActivitiesAPIListRunbookActivitiesOrganization(organizationId: string, runbookId?: string, pageLimit?: string, pageCursor?: string, type?: RunbookActivitiesAPIListRunbookActivitiesOrganizationTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRunbookActivitiesOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookActivitiesAPIListRunbookActivitiesOrganization(organizationId, runbookId, pageLimit, pageCursor, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookActivitiesAPIApi.runbookActivitiesAPIListRunbookActivitiesOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates runbook activity for a runbook.
         * @summary Updates runbook activity for a runbook.
         * @param {string} organizationId The ID of the organization this runbook activity belongs to.
         * @param {string} clusterId The ID of the cluster this runbook activity belongs to.
         * @param {string} id The ID of the runbook activity.
         * @param {UpdateRunbookActivityRequest} updateRunbookActivityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbookActivitiesAPIUpdateRunbookActivity(organizationId: string, clusterId: string, id: string, updateRunbookActivityRequest: UpdateRunbookActivityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbookActivitiesAPIUpdateRunbookActivity(organizationId, clusterId, id, updateRunbookActivityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbookActivitiesAPIApi.runbookActivitiesAPIUpdateRunbookActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RunbookActivitiesAPIApi - factory interface
 * @export
 */
export const RunbookActivitiesAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RunbookActivitiesAPIApiFp(configuration)
    return {
        /**
         * Creates runbook activity for a cluster-scoped runbook.
         * @summary Create runbook activity for a cluster-scoped runbook.
         * @param {RunbookActivitiesAPIApiRunbookActivitiesAPICreateClusterRunbookActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookActivitiesAPICreateClusterRunbookActivity(requestParameters: RunbookActivitiesAPIApiRunbookActivitiesAPICreateClusterRunbookActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunbookActivity> {
            return localVarFp.runbookActivitiesAPICreateClusterRunbookActivity(requestParameters.runbookActivityOrganizationId, requestParameters.runbookActivityClusterId, requestParameters.createClusterRunbookActivityRequestRunbookActivity, options).then((request) => request(axios, basePath));
        },
        /**
         * List runbook activities for a cluster-scoped runbook.
         * @summary List runbook activities for a cluster-scoped runbook.
         * @param {RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesClusterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookActivitiesAPIListRunbookActivitiesCluster(requestParameters: RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesClusterRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRunbookActivitiesClusterResponse> {
            return localVarFp.runbookActivitiesAPIListRunbookActivitiesCluster(requestParameters.organizationId, requestParameters.clusterId, requestParameters.runbookId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.type, requestParameters.runbookType, requestParameters.entityId, requestParameters.pullRequestMetadataId, requestParameters.pullRequestMetadataUri, requestParameters.pullRequestMetadataBranch, requestParameters.pullRequestMetadataFilesChanged, requestParameters.pullRequestMetadataStatus, requestParameters.pullRequestMetadataActivityStatus, requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * List runbook activities for an organization-scoped runbook.
         * @summary List runbook activities for an organization-scoped runbook.
         * @param {RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookActivitiesAPIListRunbookActivitiesOrganization(requestParameters: RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRunbookActivitiesOrganizationResponse> {
            return localVarFp.runbookActivitiesAPIListRunbookActivitiesOrganization(requestParameters.organizationId, requestParameters.runbookId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates runbook activity for a runbook.
         * @summary Updates runbook activity for a runbook.
         * @param {RunbookActivitiesAPIApiRunbookActivitiesAPIUpdateRunbookActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbookActivitiesAPIUpdateRunbookActivity(requestParameters: RunbookActivitiesAPIApiRunbookActivitiesAPIUpdateRunbookActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.runbookActivitiesAPIUpdateRunbookActivity(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.updateRunbookActivityRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for runbookActivitiesAPICreateClusterRunbookActivity operation in RunbookActivitiesAPIApi.
 * @export
 * @interface RunbookActivitiesAPIApiRunbookActivitiesAPICreateClusterRunbookActivityRequest
 */
export interface RunbookActivitiesAPIApiRunbookActivitiesAPICreateClusterRunbookActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPICreateClusterRunbookActivity
     */
    readonly runbookActivityOrganizationId: string

    /**
     * 
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPICreateClusterRunbookActivity
     */
    readonly runbookActivityClusterId: string

    /**
     * 
     * @type {CreateClusterRunbookActivityRequestRunbookActivity}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPICreateClusterRunbookActivity
     */
    readonly createClusterRunbookActivityRequestRunbookActivity: CreateClusterRunbookActivityRequestRunbookActivity
}

/**
 * Request parameters for runbookActivitiesAPIListRunbookActivitiesCluster operation in RunbookActivitiesAPIApi.
 * @export
 * @interface RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesClusterRequest
 */
export interface RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesClusterRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly clusterId: string

    /**
     * The ID of the runbook.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly runbookId?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly pageCursor?: string

    /**
     * The type of the runbook activity.
     * @type {'RUNBOOK_ACTIVITY_TYPE_UNSPECIFIED' | 'PULL_REQUEST' | 'AGENT_HARD_FAILURE' | 'AGENT_SOFT_FAILURE' | 'AGENT_PROGRESS'}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly type?: RunbookActivitiesAPIListRunbookActivitiesClusterTypeEnum

    /**
     * The type of the runbook.
     * @type {'RUNBOOK_TYPE_UNSPECIFIED' | 'WOOP_RECOMMENDATIONS_SYNC' | 'IMAGE_VULNERABILITY_REMEDIATION' | 'DATABASE_INDEX_OPTIMIZER' | 'COMPLIANCE_FIX' | 'DISCOVERY_AGENT' | 'PROBE_ADDER'}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly runbookType?: RunbookActivitiesAPIListRunbookActivitiesClusterRunbookTypeEnum

    /**
     * The optional entity id.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly entityId?: string

    /**
     * The ID of the pull request.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly pullRequestMetadataId?: string

    /**
     * The URI of the pull request.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly pullRequestMetadataUri?: string

    /**
     * The branch of the pull request.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly pullRequestMetadataBranch?: string

    /**
     * A list of files changed in the pull request.
     * @type {Array<string>}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly pullRequestMetadataFilesChanged?: Array<string>

    /**
     * The status of the runbook activity.
     * @type {'PULL_REQUEST_STATUS_UNSPECIFIED' | 'OPENED' | 'MERGED' | 'CLOSED'}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly pullRequestMetadataStatus?: RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataStatusEnum

    /**
     * The status of the activity. Used to indicate if this activity is new, or it has already been observed by the agent.
     * @type {'ACTIVITY_STATUS_UNSPECIFIED' | 'NEW' | 'PROCESSED'}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly pullRequestMetadataActivityStatus?: RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataActivityStatusEnum

    /**
     * The ID of the runbook run.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesCluster
     */
    readonly runId?: string
}

/**
 * Request parameters for runbookActivitiesAPIListRunbookActivitiesOrganization operation in RunbookActivitiesAPIApi.
 * @export
 * @interface RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganizationRequest
 */
export interface RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganizationRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganization
     */
    readonly organizationId: string

    /**
     * The ID of the runbook.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganization
     */
    readonly runbookId?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganization
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganization
     */
    readonly pageCursor?: string

    /**
     * The type of the runbook activity.
     * @type {'RUNBOOK_ACTIVITY_TYPE_UNSPECIFIED' | 'PULL_REQUEST' | 'AGENT_HARD_FAILURE' | 'AGENT_SOFT_FAILURE' | 'AGENT_PROGRESS'}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganization
     */
    readonly type?: RunbookActivitiesAPIListRunbookActivitiesOrganizationTypeEnum
}

/**
 * Request parameters for runbookActivitiesAPIUpdateRunbookActivity operation in RunbookActivitiesAPIApi.
 * @export
 * @interface RunbookActivitiesAPIApiRunbookActivitiesAPIUpdateRunbookActivityRequest
 */
export interface RunbookActivitiesAPIApiRunbookActivitiesAPIUpdateRunbookActivityRequest {
    /**
     * The ID of the organization this runbook activity belongs to.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIUpdateRunbookActivity
     */
    readonly organizationId: string

    /**
     * The ID of the cluster this runbook activity belongs to.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIUpdateRunbookActivity
     */
    readonly clusterId: string

    /**
     * The ID of the runbook activity.
     * @type {string}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIUpdateRunbookActivity
     */
    readonly id: string

    /**
     * 
     * @type {UpdateRunbookActivityRequest}
     * @memberof RunbookActivitiesAPIApiRunbookActivitiesAPIUpdateRunbookActivity
     */
    readonly updateRunbookActivityRequest: UpdateRunbookActivityRequest
}

/**
 * RunbookActivitiesAPIApi - object-oriented interface
 * @export
 * @class RunbookActivitiesAPIApi
 * @extends {BaseAPI}
 */
export class RunbookActivitiesAPIApi extends BaseAPI {
    /**
     * Creates runbook activity for a cluster-scoped runbook.
     * @summary Create runbook activity for a cluster-scoped runbook.
     * @param {RunbookActivitiesAPIApiRunbookActivitiesAPICreateClusterRunbookActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookActivitiesAPIApi
     */
    public runbookActivitiesAPICreateClusterRunbookActivity(requestParameters: RunbookActivitiesAPIApiRunbookActivitiesAPICreateClusterRunbookActivityRequest, options?: RawAxiosRequestConfig) {
        return RunbookActivitiesAPIApiFp(this.configuration).runbookActivitiesAPICreateClusterRunbookActivity(requestParameters.runbookActivityOrganizationId, requestParameters.runbookActivityClusterId, requestParameters.createClusterRunbookActivityRequestRunbookActivity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List runbook activities for a cluster-scoped runbook.
     * @summary List runbook activities for a cluster-scoped runbook.
     * @param {RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesClusterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookActivitiesAPIApi
     */
    public runbookActivitiesAPIListRunbookActivitiesCluster(requestParameters: RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesClusterRequest, options?: RawAxiosRequestConfig) {
        return RunbookActivitiesAPIApiFp(this.configuration).runbookActivitiesAPIListRunbookActivitiesCluster(requestParameters.organizationId, requestParameters.clusterId, requestParameters.runbookId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.type, requestParameters.runbookType, requestParameters.entityId, requestParameters.pullRequestMetadataId, requestParameters.pullRequestMetadataUri, requestParameters.pullRequestMetadataBranch, requestParameters.pullRequestMetadataFilesChanged, requestParameters.pullRequestMetadataStatus, requestParameters.pullRequestMetadataActivityStatus, requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List runbook activities for an organization-scoped runbook.
     * @summary List runbook activities for an organization-scoped runbook.
     * @param {RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookActivitiesAPIApi
     */
    public runbookActivitiesAPIListRunbookActivitiesOrganization(requestParameters: RunbookActivitiesAPIApiRunbookActivitiesAPIListRunbookActivitiesOrganizationRequest, options?: RawAxiosRequestConfig) {
        return RunbookActivitiesAPIApiFp(this.configuration).runbookActivitiesAPIListRunbookActivitiesOrganization(requestParameters.organizationId, requestParameters.runbookId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates runbook activity for a runbook.
     * @summary Updates runbook activity for a runbook.
     * @param {RunbookActivitiesAPIApiRunbookActivitiesAPIUpdateRunbookActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbookActivitiesAPIApi
     */
    public runbookActivitiesAPIUpdateRunbookActivity(requestParameters: RunbookActivitiesAPIApiRunbookActivitiesAPIUpdateRunbookActivityRequest, options?: RawAxiosRequestConfig) {
        return RunbookActivitiesAPIApiFp(this.configuration).runbookActivitiesAPIUpdateRunbookActivity(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.updateRunbookActivityRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const RunbookActivitiesAPIListRunbookActivitiesClusterTypeEnum = {
    RUNBOOK_ACTIVITY_TYPE_UNSPECIFIED: 'RUNBOOK_ACTIVITY_TYPE_UNSPECIFIED',
    PULL_REQUEST: 'PULL_REQUEST',
    AGENT_HARD_FAILURE: 'AGENT_HARD_FAILURE',
    AGENT_SOFT_FAILURE: 'AGENT_SOFT_FAILURE',
    AGENT_PROGRESS: 'AGENT_PROGRESS'
} as const;
export type RunbookActivitiesAPIListRunbookActivitiesClusterTypeEnum = typeof RunbookActivitiesAPIListRunbookActivitiesClusterTypeEnum[keyof typeof RunbookActivitiesAPIListRunbookActivitiesClusterTypeEnum];
/**
 * @export
 */
export const RunbookActivitiesAPIListRunbookActivitiesClusterRunbookTypeEnum = {
    RUNBOOK_TYPE_UNSPECIFIED: 'RUNBOOK_TYPE_UNSPECIFIED',
    WOOP_RECOMMENDATIONS_SYNC: 'WOOP_RECOMMENDATIONS_SYNC',
    IMAGE_VULNERABILITY_REMEDIATION: 'IMAGE_VULNERABILITY_REMEDIATION',
    DATABASE_INDEX_OPTIMIZER: 'DATABASE_INDEX_OPTIMIZER',
    COMPLIANCE_FIX: 'COMPLIANCE_FIX',
    DISCOVERY_AGENT: 'DISCOVERY_AGENT',
    PROBE_ADDER: 'PROBE_ADDER'
} as const;
export type RunbookActivitiesAPIListRunbookActivitiesClusterRunbookTypeEnum = typeof RunbookActivitiesAPIListRunbookActivitiesClusterRunbookTypeEnum[keyof typeof RunbookActivitiesAPIListRunbookActivitiesClusterRunbookTypeEnum];
/**
 * @export
 */
export const RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataStatusEnum = {
    PULL_REQUEST_STATUS_UNSPECIFIED: 'PULL_REQUEST_STATUS_UNSPECIFIED',
    OPENED: 'OPENED',
    MERGED: 'MERGED',
    CLOSED: 'CLOSED'
} as const;
export type RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataStatusEnum = typeof RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataStatusEnum[keyof typeof RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataStatusEnum];
/**
 * @export
 */
export const RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataActivityStatusEnum = {
    ACTIVITY_STATUS_UNSPECIFIED: 'ACTIVITY_STATUS_UNSPECIFIED',
    NEW: 'NEW',
    PROCESSED: 'PROCESSED'
} as const;
export type RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataActivityStatusEnum = typeof RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataActivityStatusEnum[keyof typeof RunbookActivitiesAPIListRunbookActivitiesClusterPullRequestMetadataActivityStatusEnum];
/**
 * @export
 */
export const RunbookActivitiesAPIListRunbookActivitiesOrganizationTypeEnum = {
    RUNBOOK_ACTIVITY_TYPE_UNSPECIFIED: 'RUNBOOK_ACTIVITY_TYPE_UNSPECIFIED',
    PULL_REQUEST: 'PULL_REQUEST',
    AGENT_HARD_FAILURE: 'AGENT_HARD_FAILURE',
    AGENT_SOFT_FAILURE: 'AGENT_SOFT_FAILURE',
    AGENT_PROGRESS: 'AGENT_PROGRESS'
} as const;
export type RunbookActivitiesAPIListRunbookActivitiesOrganizationTypeEnum = typeof RunbookActivitiesAPIListRunbookActivitiesOrganizationTypeEnum[keyof typeof RunbookActivitiesAPIListRunbookActivitiesOrganizationTypeEnum];
